module.exports = __webpack_public_path__ + "static/shc1-68b412a237cddffd47692a77ebfcd2d6.png";